import { Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[NoTriggerBlur]'
})
export class NoTriggerBlurDirective {

  constructor() {}

  @HostListener('mousedown', ['$event']) onMousedown(event:Event) {
    event.preventDefault();
    event.stopPropagation();
  }

}
